import PropTypes from 'prop-types';
import { Container } from '@mui/material';

import { SIDEBAR_WIDTH } from 'constants/components';
import { useBreakpointFlags } from 'hooks/useBreakpointFlags';

const fullWidthSx = ({ breakpoints }) => ({
  [breakpoints.up('xl')]: {
    paddingInline: `${SIDEBAR_WIDTH + 48}px`,
  },
  [breakpoints.up('xxl')]: {
    paddingInline: `${SIDEBAR_WIDTH + 68}px`,
  },
});

const PageContainer = ({ maxWidth = undefined, sx: sxProp = undefined, children, ...props }) => {
  const { isXxlUp: isXXLDesktop } = useBreakpointFlags();
  const defaultMaxWidth = isXXLDesktop ? 'xl' : 'lg';
  const isFullWidth = maxWidth === false;

  return (
    <Container maxWidth={maxWidth ?? defaultMaxWidth} sx={[sxProp, isFullWidth && fullWidthSx]} {...props}>
      {children}
    </Container>
  );
};

PageContainer.propTypes = {
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  sx: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.array]),
  children: PropTypes.node.isRequired,
};
export default PageContainer;
